<template>
    <el-menu-item  v-if="!item.hidden &&
      hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item
            v-show="onlyOneChild.meta"
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="generateTitle(onlyOneChild.meta.title)"
          />
    </el-menu-item>
    <el-submenu v-else-if="!item.hidden" ref="subMenu" :index="resolvePath(item.path)">
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="generateTitle(item.meta.title)"
        />
      </template>
      <div v-for="child in item.children" :key="child.path">
        <menu-item
          v-if="!child.hidden && hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
          :is-nest="true"
          :item="child"
          :base-path="resolvePath(child.path)"
          class="nest-menu"
        >
          <item
            v-if="child.meta"
            :icon="child.meta.icon || (item.meta && item.meta.icon)"
            :title="generateTitle(child.meta.title)"
          />
        </menu-item>
        <el-submenu v-else
          :item="child"
          :base-path="resolvePath(child.path)"
          class="nest-menu"
        >
        <item
          v-if="child.meta"
          :icon="child.meta.icon || (item.meta && item.meta.icon)"
          :title="generateTitle(child.meta.title)"
        />
       </el-submenu>
      </div>
    </el-submenu>
</template>
<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils/validate'
import Item from './Item'
// import AppLink from './Link'
import FixiOSBug from './FixiOSBugT'
export default {
  name: 'TopbarItem',
  components: { Item, /* AppLink */},
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })
      // When there is only one child router, the child router is displayed by default
      // if (showingChildren.length === 1) {
      //  return true
      // }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },
    generateTitle
  }
}
</script>
